<template>
  <div>
    <div :class="outerContainerClass">
      <div
        v-if="pending"
        class="sf-progress-complete sf-bg-snow sf-progress__pending"
        data-testid="sf-progress-pending"
      />
      <sf-progress-total-percentage
        v-else
        :sections="sections"
        :show-total-percentage="showTotalPercentage"
      >
        <template #percentage-label>
          <slot name="percentage-label" :sections="sections">
            <sf-progress-percentage-numeric :sections="sections" />
          </slot>
        </template>
      </sf-progress-total-percentage>
    </div>

    <div v-if="showLegend" class="sf-align-c sf-below-2">
      <sf-progress-legend :sections="sections" />
    </div>
  </div>
</template>

<script>
import SfProgressLegend from './sf-progress-legend'
import SfProgressPercentageNumeric from './sf-progress-percentage-numeric'
import SfProgressTotalPercentage from './sf-progress-total-percentage'

export default {
  components: {
    SfProgressLegend,
    SfProgressPercentageNumeric,
    SfProgressTotalPercentage,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
    sections: {
      type: Array,
      required: true,
    },
    showLegend: {
      type: Boolean,
      required: false,
      default: false,
    },
    showTotalPercentage: {
      type: Boolean,
      required: false,
      default: false,
    },
    // "small", "tiny", or null (= regular size)
    size: {
      type: String,
      default: 'small',
    },
  },

  computed: {
    outerContainerClass() {
      return {
        'sf-progress': true,
        'sf-below-2': this.showLegend,
        'sf-bg-snow': true,
        'sf-progress-small': this.size === 'small',
        'sf-progress-tiny': this.size === 'tiny',
        'sf-progress-animate': this.pending,
        'sf-dim-el': this.disabled,
        'sf-progress__outer-container': true,
      }
    },
  },
}
</script>

<style scoped lang="scss">
.sf-progress {
  &__outer-container {
    position: relative;
  }

  &__pending {
    width: 100%;
  }
}
</style>
